import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { uuidValidator } from '../../validators';

export const MeResponseSchema = z.object({
  email: z.string().email(),
  id: uuidValidator,
  language: z.nativeEnum(LanguageEnum),
  picture: z.string().url().nullable().optional(),
  provider: z.string().nullable().optional(),
  providerId: z.string().nullable().optional(),
  tokenVersion: z.number().int().optional(),
  useOwnLlm: z.boolean().optional(),
  username: z.string(),
});

export type IMeResponseDto = z.infer<typeof MeResponseSchema>;
